const actions = {
  setLocationFrom({ commit }, location) {
    commit('setLocationFrom', location);
  },
  setLocationTo({ commit }, location) {
    commit('setLocationTo', location);
  },
  clearDestinations({ commit }) {
    commit('clearDestinations');
  },
  setPickUpRange({ commit }, payload) {
    commit('setPickUpRange', payload);
  },
  clearPickUpRange({ commit }) {
    commit('clearPickUpRange');
  },
  completeCalculate({ commit }, result) {
    commit('completeCalculate', result);
  },
  resetCalculation({ commit }) {
    commit('resetCalculation');
  },
  setNearestServicePoints({ commit }, servicePoints) {
    commit('setNearestServicePoints', servicePoints);
  },
  clearNearestServicePoints({ commit }) {
    commit('clearNearestServicePoints');
  },
  setP2pPServicePoints({ commit }, servicePoints) {
    commit('setP2pPServicePoints', servicePoints);
  },
  clearP2pPServicePoints({ commit }) {
    commit('clearP2pPServicePoints');
  },
  setCenterCoordinateMap({ commit }, coordinate) {
    commit('setCenterCoordinateMap', coordinate);
  },
  clearCenterCoordinateMap({ commit }) {
    commit('clearCenterCoordinateMap');
  },
  updatePiece({ dispatch, getters }, piece) {
    if (getters.pieces.find((p) => p.id === piece.id)) {
      dispatch('editPiece', piece);
    } else {
      dispatch('addPiece', piece);
    }
  },
  addPiece({ commit }, piece) {
    commit('addPiece', piece);
  },
  editPiece({ commit }, piece) {
    commit('editPiece', piece);
  },
  removePiece({ commit }, piece) {
    commit('removePiece', piece.id);
  },
  setOrderType({ commit }, orderType) {
    commit('setOrderType', orderType);
    commit('updatePayment', null);
    commit('updateSuccessShipmentResult', null);
  },
  setOrder({ commit }, order) {
    commit('setOrder', order);
  },
  setServicePoints({ commit }, servicePoints) {
    commit('setServicePoints', servicePoints);
  },
  setServicePointFrom({ commit }, servicePoint) {
    commit('setServicePointFrom', servicePoint);
  },
  setServicePointTo({ commit }, servicePoint) {
    commit('setServicePointTo', servicePoint);
  },
  setCalculatedProducts({ commit }, products) {
    commit('setCalculatedProducts', products);
  },
  resetCalculatedProducts({ commit }) {
    commit('resetCalculatedProducts');
  },
  setProduct({ commit }, product) {
    commit('setProduct', product);
    commit('removeAllExtra');
  },
  removeAllExtra({ commit }) {
    commit('addExtra');
  },
  addExtra({ commit }, extra) {
    commit('addExtra', extra);
  },
  removeExtra({ commit }, extra) {
    commit('removeExtra', extra);
  },
  setSenderContacts({ commit }, senderData) {
    commit('setSenderContacts', senderData);
  },
  setReceiverContacts({ commit }, receiverData) {
    commit('setReceiverContacts', receiverData);
  },
  setDeclaredValue({ commit }, value) {
    commit('setDeclaredValue', value);
  },
  setInsuredAmount({ commit }, value) {
    commit('setInsuredAmount', value);
  },
  enableCustomsDuty({ commit }) {
    commit('enableCustomsDuty');
  },
  disableCustomsDuty({ commit }) {
    commit('disableCustomsDuty');
  },
  updatePayment({ commit }, payment) {
    commit('updatePayment', payment);
  },
  setCustomDutyAmount({ commit }, value) {
    commit('setCustomDutyAmount', value);
  },
  setOnlineCardPaymentEmail({ commit }, value) {
    commit('setOnlineCardPaymentEmail', value);
  },
  updateSuccessShipmentResult({ commit }, value) {
    commit('updateSuccessShipmentResult', value);
  },
  setExtraTestXK({ commit }) {
    commit('setExtraTestXK');
  },
  updateCalculateResultStored({ commit }, payment) {
    commit('updateCalculateResultStored', payment);
  },
  setPickUpAvailableTimes({ commit }, value) {
    commit('setPickUpAvailableTimes', value);
  },
  setPickUpAvailableWeekend({ commit }, value) {
    commit('setPickUpAvailableWeekend', value);
  },
  setPickUpDate({ commit }, value) {
    commit('setPickUpDate', value);
  },
  setPriceDiff({ commit }, value) {
    commit('setPriceDiff', value);
  },
  setLegalInfo({ commit }, legalData) {
    commit('setLegalInfo', legalData);
  },
  setPointWalk({ commit }, value) {
    commit('setPointWalk', value);
  },
  async filterServicePointListOnCity(
    { state, dispatch, rootState },
    { cityName, isP2p },
  ) {
    const checkCoordinate = async (point) => {
      const isCoordinates =
        point.coordinates &&
        point.coordinates.latitude &&
        point.coordinates.longitude;

      if (!isCoordinates) {
        const { loadYmap } = await import('vue-yandex-maps');
        const { apiKey } = state.yandexMapSettings;
        let lang = 'ru_RU';
        if (rootState.api.language !== 'ru') {
          lang = 'en_US';
        }

        const ymaps = await loadYmap({
          apiKey,
          lang,
          version: '2.1',
          coordorder: 'latlong',
        }).catch(() => {
          return null;
        });

        if (!ymaps) {
          return point;
        }

        const res = await ymaps.geocode(`${point.city} ${point.address}`);
        const firstResult = res.geoObjects.get(0);

        if (firstResult) {
          const [latitude, longitude] = firstResult.geometry.getCoordinates();
          point.coordinates = {
            latitude,
            longitude,
          };
        } else {
          point.coordinates = null;
        }
      }

      return point;
    };

    const servicePointList = await Promise.all(
      state.servicePoints
        .filter((point) => point.city === cityName)
        .map((point) => checkCoordinate(point)),
    );

    if (isP2p) {
      dispatch('setP2pPServicePoints', servicePointList);
    } else {
      dispatch('setNearestServicePoints', servicePointList);
    }
  },
  setInvoiceStatus({ commit }, status) {
    commit('setInvoiceStatus', status);
  },
  setInvoiceType({ commit }, type) {
    commit('setInvoiceType', type);
  },
  setInvoiceCurrency({ commit }, currency) {
    commit('setInvoiceCurrency', currency);
  },
  setInvoiceItem({ commit }, { id, item }) {
    commit('setInvoiceItem', {
      id,
      item,
    });
  },
  setInvoicePrice({ commit }, price) {
    commit('setInvoicePrice', price);
  },
  editInvoiceItem({ commit, state }, id) {
    const invoice = state.invoice.list[id];
    commit('setInvoiceItem', {
      id,
      item: {
        ...invoice,
        isEdit: true,
      },
    });
  },
  cancelInvoiceItem({ commit, state }, id) {
    const invoice = state.invoice.list[id];
    commit('setInvoiceItem', {
      id,
      item: {
        ...invoice,
        isEdit: false,
      },
    });
  },
  removeInvoiceItem({ commit, state }, id) {
    const invoice = state.invoice.list[id];
    commit('setInvoiceItem', {
      id,
      item: {
        ...invoice,
        isDeleted: true,
      },
    });
  },
  recoverInvoiceItem({ commit, state }, id) {
    const invoice = state.invoice.list[id];
    commit('setInvoiceItem', {
      id,
      item: {
        ...invoice,
        isDeleted: false,
      },
    });
  },
  setCalcDeliverySet({ commit }, { setting, status }) {
    commit('setCalcDeliverySet', { setting, status });
  },
};

export default actions;
